module.exports = __webpack_public_path__ + "img/loca_edu_bg.28af350c.png";